<template>
  <div>
    <legend class="mb-5">
      {{ label }}
    </legend>
    <div class="row pl-1" id="nps">
      <div class="column" v-for="index in 11" :key="index">
        <label :class="'btn btn-md labelScore label' + (index - 1) + ' ' + borderColor[index - 1] + (index - 1)">
        <input type="radio" name="radio-btn-outline" autocomplete="off" class="input-nps" :value="index - 1" v-model="score" @click="changeBorderColor(index - 1)">
        <span>{{ index - 1 }}</span>
        </label>
      </div>
    </div>
    <div class="legenda-nps">
      <p>Muito improvável</p>
      <p>Muito provável</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Score',
  props: {
    scoreProps: Number,
    companyName: String
  },
  data () {
    return {
      label: '',
      borderColor: []
    }
  },
  watch: {
    scoreProps () {
      this.$emit('update-commentary')
    }
  },
  created () {
    if (!this.companyName) {
      this.companyName = 'o Jaleko'
    }
    this.label = `Em uma escala de 0 a 10, qual a probabilidade de você recomendar ${this.companyName} a um amigo ou colega?`
  },
  computed: {
    score: {
      get: function () {
        return this.scoreProps
      },
      set: function (newValue) {
        this.$emit('update-score', newValue)
      }
    }
  },
  methods: {
    changeBorderColor (value) {
      this.borderColor = []
      this.borderColor[value] = 'labelSelected'
    }
  }
}
</script>
